module.exports = __webpack_public_path__ + "img/shield.483f0f04.jpg";